define('home/views/HomepageOnboardingModuleView',[
    'underscore',
    'backbone-marionette',

    'home/models/Session',
    'home/mixins/withOnboarding',
    'home/templates/homepageOnboardingModule',
], function (
    _,
    Marionette,

    Session,
    withOnboarding,
    homepageOnboardingModuleTemplate
) {
    'use strict';

    var HomepageOnboardingModuleView = Marionette.ItemView.extend({
        template: homepageOnboardingModuleTemplate,
        templateHelpers: function () {
            var channelsFollowing = this.getChannelsFollowing();

            // If showing an overcount count, show 1 fewer channel so there's always 3 items shown.
            // ex: x, y, and z OR z, y, and 2 more
            var numShown = channelsFollowing.length <= this.constructor.MAX_CHANNELS_SHOWN ?
                channelsFollowing.length :
                this.constructor.MAX_CHANNELS_SHOWN - 1;

            var overflowCount = Math.max(channelsFollowing.length - numShown, 0);

            var channels = _.chain(channelsFollowing)
                .first(numShown)
                .map(function (channel, index) {
                    return ['channel' + index, channel.get('name')];
                })
                .object()
                .value();

            var data = _.extend({
                numShown: numShown,
                overflowCount: overflowCount,
                onboardingWithoutChannels: this.onboardingWithoutChannels,
            }, channels);

            return data;
        },

        events: {
            'click [data-role=complete-onboarding]': 'markOnboardingComplete',
            'click [data-role=hide-onboarding]': 'hideOnboarding',
        },

        initialize: function (options) {
            this.onboardingWithoutChannels = options.onboardingWithoutChannels;
            this.session = Session.get();
            this.session.loadPromise().then(_.bind(function () {
                var forumsFollowing = this.session.getUserProfile().forumsFollowing;
                this.listenTo(forumsFollowing.items, 'add remove reset', this.render);
            }, this));
        },

        markOnboardingComplete: function () {
            var sessionUser = this.session.user;
            sessionUser.updateFlags({
                homeFeedOnboardingComplete: true,
            });
        },

        hideOnboarding: function () {
            this.markOnboardingComplete();
            this.trigger('hideOnboarding');
        },
    }, {

        // WARNING: Do not change without updating template for proper translations
        MAX_CHANNELS_SHOWN: 3,
    });

    withOnboarding.call(HomepageOnboardingModuleView.prototype);

    return HomepageOnboardingModuleView;
});

